
import { Routes, Route } from "react-router"

import { NotFoundPage } from "../pages/auth/NotFoundPage"

import { AdministracionPage } from "../pages/admin/AdministracionPage"
import { ApiKeysPage } from "../pages/admin/ApiKeysPage"
import { UsuariosPage } from "../pages/admin/UsuariosPage"

import { TipoServicioPage } from "../pages/catalogos/TipoServicioPage"
import { UnidadPage } from "../pages/catalogos/UnidadPage"

export const KioscoRoutes = () => {

    return (

        <Routes>
            
            <Route path="/administracion" element={ <AdministracionPage /> } />   

            <Route path="/administracion/catalogos/unidad" element={ <UnidadPage /> } />   

            <Route path="/administracion/catalogos/tipoServicio" element={ <TipoServicioPage/> } />   

            <Route path="/administracion/usuarios" element={ <UsuariosPage/> } />   

            <Route path="/administracion/apikeys" element={ <ApiKeysPage/> } />    

            <Route path="*" element={ <NotFoundPage /> } /> 

        </Routes>        
    
    )
}